// extracted by mini-css-extract-plugin
export var light = "subtitle-module--light--99b8f";
export var subtitle = "subtitle-module--subtitle--dcaa8";